import type { EnvironmentId } from "@cmmd-forge/contracts";

export const CLOUD_MACHINE_INVENTORY_PATH = "/api/admin/runtime/diagnostics" as const;

/**
 * Recheck on a Sleeping Environment is Execution Intent. The inventory GET
 * is the probe. Selection never reaches this function.
 */
export function cloudInventoryRecheckIsExecutionIntent(): true {
  return true;
}

export function shouldFetchCloudMachineInventory(input: {
  readonly action: "select" | "recheck";
  readonly isPlatformAdmin: boolean;
  readonly selectedEnvironmentId: EnvironmentId | null;
}): boolean {
  return (
    input.action === "recheck" && input.isPlatformAdmin && input.selectedEnvironmentId !== null
  );
}

export function thisServerInventoryCopy(): string {
  return "Machine inventory for this server.";
}

export async function fetchCloudMachineInventoryJson(
  url: string,
  init: RequestInit,
): Promise<unknown> {
  const response = await fetch(url, init);
  if (response.status >= 200 && response.status < 300) {
    return response.json();
  }
  let message = `Machine inventory is unavailable (${response.status}).`;
  try {
    const body = (await response.json()) as { readonly error?: string };
    if (typeof body.error === "string" && body.error.length > 0) {
      message = body.error;
    }
  } catch {
    // Keep the status fallback when the error body is not JSON.
  }
  throw new Error(message);
}

export function spriteInventoryCopy(): string {
  return "Machine inventory for this Sprite, collected on Recheck. Recheck is Execution Intent.";
}
